module.exports = __webpack_public_path__ + "img/back_top.ff5e76e2.png";